import { takeLatest, put, call } from 'redux-saga/effects';
import { ActionTypes } from '../actions/actionTypes';
import { getVisibilityUserSetting } from '../apis/visibilityUserSettings';
import { VisibilityUserSettings } from '../constants/online.homepagegateway.api';

export function* callFetchUserSettingsApi() {
    try {
        const userSettings: VisibilityUserSettings = yield call(getVisibilityUserSetting);
        yield put({
            type: ActionTypes.FETCH_USER_SETTINGS_SUCCESS,
            payload: userSettings
        });
    }
    catch (error) {
        yield put({
            type: ActionTypes.FETCH_USER_SETTINGS_FAILURE,
            payload: error
        });
    }
}

export function* watchFetchUserSettings() {
    yield takeLatest(ActionTypes.FETCH_USER_SETTINGS_INIT, callFetchUserSettingsApi);
}